<template>
    <div class="h-screen flex overflow-hidden bg-gray-100">
        <side-bar></side-bar>

        <div class="w-full h-full overflow-hidden">

            <nav-bar></nav-bar>
            <bread-crumb :disabled="disableBreadcrumb" :preset="presetBreadcrumbs"></bread-crumb>
            <main class="w-full h-full flex-1 relative overflow-y-auto focus:outline-none py-2 px-8 pb-48">
                <clip-loader v-if="loader"></clip-loader>
                <slot v-else></slot>
            </main>

            <footer-bar></footer-bar>
        </div>
    </div>
</template>

<style>
</style>

<script>
    import Sidebar from "../layouts/Sidebar.vue";
    import Nav from "../layouts/Nav.vue";
    import Header from "../layouts/Header.vue";
    import Footer from "../layouts/Footer.vue";
    import BreadCrumb from "../layouts/BreadCrumb.vue";
    import localeChange from "../mixins/localeChange";
    import { wide_screen_route } from "Resources/config/route";
    import helper from "Resources/util/helper";

    export default {
        name:"MainLayout",

        mixins: [localeChange],

        props: {
            header: {
                default: "",
                type: String,
                required: false
            },
            loader: {
                default: false,
                type: Boolean,
                required: false
            },
            disableBreadcrumb: { 
                default: false,
                type: Boolean,
                required: false
            },
            presetBreadcrumbs: {
                default: null,
                type: [Object, Array],
                required: false
            },
        },

        components:{
            'side-bar'  : Sidebar,
            'nav-bar'   : Nav,
            'header-bar': Header,
            'footer-bar': Footer,
            'bread-crumb': BreadCrumb,
        },

        data(){
            return{
                user: this.$store.state.auth.user,
                locale: this.locale,
            }
        },
        mounted(){

            let _self = this;
            // to hide sidebar when current page is label form
            if (
            wide_screen_route.includes(_self.$route.name) &&
            !$("#sidebar").hasClass("minimize")
            ) {
            $("#sidebar").addClass("minimize");
            }
            this.loadClass;
        },

        computed: {
            loadClass() {
                document.body.setAttribute('id', helper.getNestedValue('meta.bodyClass', this.$route, ''));
            }
        },

        methods:{}
    };
</script>